import { numberToUsFormat, numberToUsd } from '@/helpers/valueFormatter/numberFormatter.helpers';

export interface ITotalRowData {
  totalImpressions?: number;
  totalSpend?: number;
  totalClicks?: number;
  // Replaces the impressions total on views whose rows carry no impressions.
  totalVisits?: number;
}

interface ITotalRowProps {
  totalRowData: ITotalRowData;
}

export const TotalRow = ({
  totalRowData: { totalImpressions, totalSpend, totalClicks, totalVisits },
}: ITotalRowProps) => {
  return (
    <div className='flex bg-[#eaeaea] border-t-2 border-[#bbb] font-bold text-[#222] px-10 py-2 rounded-b-lg'>
      <div className='flex w-1/2'>
        <div className='w-[54%]'>
          <span>{totalVisits === undefined ? 'Total Impressions:' : 'Total Visits:'}</span>
        </div>
        <div className='w-[46%]'>{numberToUsFormat(totalVisits ?? totalImpressions ?? 0)}</div>
      </div>
      {!totalSpend || (
        <div className='flex w-1/2 text-right'>
          <div className='w-[80%]'>Total Spend:</div>
          <div className='w-[20%]'>{numberToUsd(totalSpend)}</div>
        </div>
      )}
      {!totalClicks || (
        <div className='flex w-1/2 text-right'>
          <div className='w-[80%]'>Total Clicks:</div>
          <div className='w-[20%]'>{numberToUsFormat(totalClicks)}</div>
        </div>
      )}
    </div>
  );
};
